export const SearchEventRefinement = {
  ACTION_DATE: 'actionDate',
  AREAS_OF_FOCUS: 'areasOfFocus',
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  RADIUS: 'radius',
  SOURCE: 'source',
  RECENCY: 'recency',
} as const;

export const SEARCH_EVENT_REFINEMENT_NAMES = Object.values(
  SearchEventRefinement,
);

export const SEARCH_EVENT_REFINEMENT_LABELS = Object.defineProperties(
  {},
  {
    [SearchEventRefinement.AREAS_OF_FOCUS]: {
      get: () => getText('Cause Areas'),
      enumerable: true,
    },
    [SearchEventRefinement.ACTION_DATE]: {
      get: () => getText('Date'),
      enumerable: true,
    },
    [SearchEventRefinement.LOCALE]: {
      get: () => getText('Listing Language'),
      enumerable: true,
    },
    [SearchEventRefinement.LOCATION_TYPE]: {
      get: () => getText('Location Type'),
      enumerable: true,
    },
    [SearchEventRefinement.SOURCE]: {
      get: () => getText('Source'),
      enumerable: true,
    },
    [SearchEventRefinement.RADIUS]: {
      get: () => getText('Radius'),
      enumerable: true,
    },
    [SearchEventRefinement.RECENCY]: {
      get: () => getText('Recency'),
      enumerable: true,
    },
  },
) as Record<SearchEventRefinementType, string>;

export type SearchEventRefinementType =
  (typeof SearchEventRefinement)[keyof typeof SearchEventRefinement];
